<template src="./index.html">
</template>
<script>
export default {
  name: '',
  components: {
  },
  data: function() {
    return {
		value:'',
		
		meaudatas:[],
		meaudata:[
			
		]
    };
  },
  created() {
  },
  mounted() {
  	this.meaudata = JSON.parse(localStorage.getItem("ConfigurationCentermeau"))
	this.meaudatas=this.meaudata
  },
  methods: {
	  inputx(e){
		  this.meaudatas=[]
		for(let a = 0 ; a < this.meaudata.length ;a++){
			this.meaudatas.push({
				icon:this.meaudata[a].icon,
				resName:this.meaudata[a].resName,
				children:[],
			})
			if(this.meaudata[a].children.length!=0){
				this.meaudata[a].children.map((item1,index)=>{
					if(item1.resName.indexOf(e)==0){
						this.meaudatas[a].children.push({
							...item1
						})
					}
				})
			}
		}
		for(let a = 0 ; a < this.meaudatas.length ;a++){
			if(this.meaudatas[a].children.length==0){
				this.meaudatas.splice(a,1)
				a--
			}
		}
	  },
	  forRoute(route){
		  this.$router.push("/"+route)
	  }
  }
};
</script>


<style scoped lang="less">
 @import url('./index.less');
</style>
